import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { meta } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'My National Office',
  intlKey: 'route.my_national_office'
})
class MyNationalOfficeLocalizationFiles extends Component {
  render() {
    return (
      <div>
        <Link to={`${config.publicPath}/my-national-office/profile-questions`}>Profile questions</Link>
      </div>
    )
  }
}

export default MyNationalOfficeLocalizationFiles
